var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-select',{staticStyle:{"width":"100%"},attrs:{"options":_vm.list,"placeholder":'请选择'+_vm.name,"disabled":_vm.disabled},model:{value:(_vm.id),callback:function ($$v) {_vm.id=$$v},expression:"id"}})}
var staticRenderFns = []

export { render, staticRenderFns }